import * as yup from "yup";

export const WSIBMaximumEarningsSetupValidationSchema = yup.object().shape({
   provinceId: yup.string().required("Province is required"),
});
